<div id="file-manager" class="page-layout simple right-sidebar inner-scroll">

    <!-- SIDEBAR -->
    <fuse-sidebar class="sidebar main-sidebar" name="file-manager-main-sidebar" position="left">
        <file-manager-main-sidebar></file-manager-main-sidebar>
    </fuse-sidebar>
    <!-- / SIDEBAR -->

    <!-- CENTER -->
    <div class="center" fxFlex>

        <!-- HEADER -->
        <div class="header accent p-24" style="margin-left: 0;" fxLayout="column" fxLayoutAlign="space-between start">           

            <!-- BREADCRUMB -->
            <div class="breadcrumb text-truncate h1 pl-72" fxLayout="row" fxLayoutAlign="start center"
                 [@animate]="{value:'*',params:{x:'50px'}}">
                <div *ngFor="let path of pathArr; last  as isLast" fxLayout="row" fxLayoutAlign="start center">
                    <span>{{path}}</span>
                    <mat-icon *ngIf="!isLast" class="separator">chevron_right</mat-icon>
                </div>
            </div>
            <!-- / BREADCRUMB -->


             <!-- ADD FILE BUTTON -->
             <div class="file-uploader">
                    <input hidden type="file" #pastaInput/>
                    <button mat-fab
                            color="accent"
                            matTooltip="Enviar Arquivo"
                            class="add-file-button"
                            (click)="newArchive()"
                            aria-label="Criar Pasta"
                            [@animate]="{value:'*', params:{delay:'300ms',scale:'0.2'}}"
                            [disabled]="pastaPrincipal == false">
                        <mat-icon>add</mat-icon>
                        <mat-icon>insert_drive_file</mat-icon>
                    </button>
                </div>
                <!-- / ADD FILE BUTTON -->

            <!-- ADD FILE BUTTON -->
            <div class="file-uploader">
                <input hidden type="file" #arquivoInput/>
                <button mat-fab
                        color="warn"
                        matTooltip="Criar Nova Pasta"
                        class="add-folder-button"
                        (click)="novaPasta()"
                        aria-label="Adicionar Arquivo"
                        [@animate]="{value:'*', params:{delay:'300ms',scale:'0.2'}}">
                    <mat-icon>add</mat-icon>
                    <mat-icon>folder</mat-icon>
                </button>
            </div>
            <!-- / ADD FILE BUTTON -->

        </div>
        <!-- / HEADER -->

        <!-- CONTENT -->
        <div class="content" fusePerfectScrollbar>
            <file-list></file-list>
        </div>
        <!-- / CONTENT -->

    </div>
    <!-- / CENTER -->

    <!-- SIDEBAR -->
    <fuse-sidebar class="sidebar details-sidebar" name="file-manager-details-sidebar" position="right"
                  lockedOpen="gt-md">
        <file-manager-details-sidebar></file-manager-details-sidebar>
    </fuse-sidebar>
    <!-- / SIDEBAR -->

</div>
